import React from "react";
import ResultTag from "../components/ResultTag";
import TimeTag from "../components/TimeTag";

export const useRenderMatchResult = ()=>{
    const renderMatchGameResult = match =>{
                const hasStartedMatch = match?.resultado?.length > 1
                if(hasStartedMatch) return <ResultTag match={match} /> 
                return <TimeTag />
    }

    return{
        renderMatchGameResult
    }
}